import { Component, Input } from "@angular/core";
import { StackedProgressBarItem } from "./stackedProgressBar.component";

export class MultiProgressItem {
    public min: number;
    public max: number;
    public mainLegend: string;
    public data: StackedProgressBarItem[]; 
}

export class MultiProgressDataset {
    public items: MultiProgressItem[];
    public get sum(): number {
        if (this.items) {
            return this.items.reduce<number>((acc, x) => acc + (x.max - x.min), 0);
        } else return 0;
    }

    constructor(items: MultiProgressItem[]) {
        this.items = items;
    }
}

@Component({
    selector: "multi-progress",
    templateUrl: "./multiProgress.component.html",
    standalone: false
})
export class MultiProgressComponent {
    @Input() data: MultiProgressDataset = null;
}